import React from 'react'

export default function QuoteDetails({ quote, testId, compact = false, totalOnly = false }) {
  if (!quote?.hasContent) return null

  if (totalOnly) {
    return (
      <div
        className="pricing-quote-summary pricing-quote-summary--total-only"
        data-testid={testId}
      >
        <span>Total</span>
        {Number.isFinite(quote.totalCents) && <strong>${(quote.totalCents / 100).toFixed(2)}</strong>}
      </div>
    )
  }

  return (
    <div
      className={`pricing-quote-summary${compact ? ' pricing-quote-summary--compact' : ''}`}
      data-testid={testId}
    >
      <span>
        {quote.sheetCount > 1
          ? `${quote.sheetCount} sheets · ${quote.totalHeightInches} total in`
          : `${quote.widthInches}″ × ${quote.heightInches}″`}
      </span>
      {Number.isFinite(quote.squareFeet) && <span>{quote.squareFeet.toFixed(2)} sq ft</span>}
      {Number.isFinite(quote.rateCents) && <span>${(quote.rateCents / 100).toFixed(2)} / sq ft</span>}
      {Number.isFinite(quote.totalCents) && <strong>${(quote.totalCents / 100).toFixed(2)}</strong>}
    </div>
  )
}
